<div class="row mb-3 justify-content-center">
  <div class="col-12 col-md-6 text-center">
    <h2><b>Confiez-nous votre enfant</b></h2>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <img class="col-12" alt="Card" src="../../../../assets/images/banner/good/responsable.png" style="border-radius: 5px;" />
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12">
      <p-messages [(value)]="messagesGeneral" [enableService]="false" [closable]="true"></p-messages>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-6">
      <div class="flex flex-wrap gap-3">
        <label for="">Disposez-vous de la référence de l'apprenant ? </label>
        <div class="flex align-items-center">
          <div>
            <p-radioButton name="pizza" [value]="true" [(ngModel)]="oldStudent" [ngModelOptions]="{standalone: true}" inputId="old1"></p-radioButton>
            <label for="old1" class="ml-3 mr-4"> Oui</label>
          </div>

          <div>
            <p-radioButton name="pizza" [value]="false" [(ngModel)]="oldStudent" [ngModelOptions]="{standalone: true}" inputId="old2"></p-radioButton>
            <label for="old2" class="ml-2"> Non</label>
          </div>
        </div>
        
        <!-- <div class="flex align-items-center">
          
        </div> -->
      </div>
    </div>
  </div>
  <div *ngIf="oldStudent" class="row mt-3">
  <!-- <div *ngIf="oldStudent === 'yes'" class="row mt-3"> -->
    <div class="col-6 mt-2">
      <span class="p-float-label">
        <input
          type="text"
          id="reference"
          pInputText
          formControlName="reference"
          (input)="searchStudent(form.value.reference)"
          [autocomplete]="false"
          class="p-inputtext-sm col-12"
        />
        <label for="reference">Réference</label>
      </span>
      <span *ngIf="searchLoading">
        <div >
          <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="3" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
        </div>
      </span>
      <span *ngIf="!searchLoading && !findStudent" [ngStyle]="{color: 'var(--red-500)'}" >
        <p-messages [(value)]="messagesStudent" [enableService]="false" [closable]="false"></p-messages>
      </span>
    </div>
  </div>

  <!-- Apprenant -->
  <div class="row mt-1">
    <div class="col-6">
      <div *ngIf="!oldStudent">
      <!-- <div *ngIf="oldStudent === 'no'"> -->
        <div class="row mt-3">
          <div class="col-12">
            <p-divider>Informations sur l'APPRENANT</p-divider>
          </div>
        </div>
        <div class="row justify-content-center mt-1">
          <div class="col-12 col-md-3">
            <span class="col-12 p-float-label">
              <p-dropdown
                formControlName="genre"
                [options]="genres"
                optionLabel="description"
                class="p-inputtext-sm col-12"
              ></p-dropdown>
              <!-- <label for="nom">Nom</label> -->
            </span>
          </div>
  
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="nom"
                pInputText
                formControlName="nom"
                class="p-inputtext-sm col-12"
              />
              <label for="nom">Nom</label>
            </span>
          </div>
  
          <div class="col-12 col-md-5">
            <span class="p-float-label">
              <input
                type="text"
                id="prenom"
                pInputText
                formControlName="prenom"
                class="p-inputtext-sm col-12"
              />
              <label for="prenom">Prénom(s)</label>
            </span>
          </div>
        </div>
  
        <div class="row justify-content-center mt-5">
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <p-calendar
                [autoZIndex]="true"
                [baseZIndex]="1000"
                appendTo="body"
                [panelStyleClass]="'z-index: 10000'"
                id="dateNaissance"
                formControlName="dateNaissance"
                class="p-inputtext-sm col-12"
              ></p-calendar>
              <label for="dateNaissance">Date de naissance</label>
            </span>
          </div>
  
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="telephone"
                pInputText
                formControlName="telephone"
                class="p-inputtext-sm col-12"
              />
              <label for="telephone">Téléphone</label>
            </span>
          </div>
  
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="email"
                pInputText
                formControlName="email"
                class="p-inputtext-sm col-12"
              />
              <label for="email">Email</label>
            </span>
          </div>
        </div>
      </div>

      <!-- Responsable -->
      <div class="row mt-3">
        <div class="col-12">
          <p-divider>Responsable de l'APPRENANT</p-divider>
        </div>
      </div>
      <div formGroupName="parent">
        <div class="row justify-content-center mt-1">
          <div class="col-12 col-md-3">
            <span class="col-12 p-float-label">
              <p-dropdown
                formControlName="genre"
                [options]="genres"
                optionLabel="description"
                class="p-inputtext-sm col-12"
              ></p-dropdown>
              <!-- <label for="nom">Nom</label> -->
            </span>
          </div>

          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="nom"
                pInputText
                formControlName="nom"
                class="p-inputtext-sm col-12"
              />
              <label for="nom">Nom</label>
            </span>
          </div>
  
          <div class="col-12 col-md-5">
            <span class="p-float-label">
              <input
                type="text"
                id="prenom"
                pInputText
                formControlName="prenom"
                class="p-inputtext-sm col-12"
              />
              <label for="prenom">Prénom(s)</label>
            </span>
          </div>
        </div>
  
        <div class="row justify-content-center mt-5">
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <p-calendar
                id="dateNaissance"
                formControlName="dateNaissance"
                class="p-inputtext-sm col-12"
              ></p-calendar>
              <label for="dateNaissance">Date de naissance</label>
            </span>
          </div>
  
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="telephone"
                pInputText
                formControlName="telephone"
                class="p-inputtext-sm col-12"
              />
              <label for="telephone">Téléphone</label>
            </span>
          </div>
  
          <div class="col-12 col-md-4">
            <span class="p-float-label">
              <input
                type="text"
                id="email"
                pInputText
                formControlName="email"
                class="p-inputtext-sm col-12"
              />
              <label for="email">Email</label>
            </span>
          </div>
        </div>
  
        <div class="row justify-content-center mt-5">
          <!-- <div class="col-12 col-md-4">
            <p-dropdown class="p-inputtext-sm col-12" [options]="countries" formControlName="nationalite" [(ngModel)]="countrySelected" optionLabel="name.common" [showClear]="true" placeholder="Naltionalité">
              <ng-template pTemplate="countrySelected">
                  <div class="flex align-items-center gap-2" *ngIf="countrySelected">
                    <img [src]="countrySelected.flags.png"  width="22" height="18" [class]="'flag flag-' + countrySelected.name.common.toLowerCase()"/> {{ countrySelected.name.common }}
                  </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                  <div class="flex align-items-center gap-2">
                      <img [src]="country.flags.png"  width="22" height="18" [class]="'flag flag-' + country.name.common.toLowerCase()"/> {{ country.name.common }}
                  </div>
              </ng-template>
            </p-dropdown>
          </div> -->
  
          <div class="col-12">
            <span class="p-float-label">
              <input
                type="text"
                id="adresse"
                pInputText
                formControlName="adresse"
                class="p-inputtext-sm col-12"
              />
              <label for="adresse">Adresse de résidence</label>
            </span>
          </div>
        </div>
      </div>

    </div>

    <div class="col-6">
      <div class="row mt-3">
        <div class="col-12">
          <p-divider>Site et Offre</p-divider>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <span class="p-float-label">
                <p-dropdown
                  [options]="sites"
                  [(ngModel)]="siteSelected"
                  [ngModelOptions]="{standalone: true}"
                  optionLabel="nom"
                  placeholder="Le site"
                  class="p-inputtext-sm col-12"
                  (onChange)="changeWebsite($event)"
                ></p-dropdown>
              </span>
            </div>
          </div>

          <div *ngIf="loadingOffre" class="row mt-3">
            <div class="col-12 text-center">
              <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="3" fill="var(--surface-ground)" animationDuration=".8s"></p-progressSpinner>
            </div>
          </div>
  
          <div *ngIf="!loadingOffre" class="row mt-3">
            <div *ngIf="siteSelected && lancer.length === 0">
              <p-messages [(value)]="messagesSite" [enableService]="false" [closable]="false"></p-messages>
            </div>
            <div *ngIf="lancer.length !== 0" class="col-12">
              <div class="row">
                <div *ngFor="let element of lancer" class="col-12 col-lg-6 col-xl-6  mt-3" (click)="showCondition(element.object)">
                  <p-card class="pcardChild cursor" header="{{ element.object.offreService.offre.nom }}">
                    <ng-template pTemplate="header">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.5546188673425!2d2.3432515174438477!3d6.451177500000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1024a93cc4d20075%3A0xcb8e00ef0dd03dfa!2sSTATION%20EWELL%20CALAVI%20KPOTA!5e0!3m2!1sen!2sbj!4v1681303096630!5m2!1sen!2sbj" height="50" style="border:0; width: 100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </ng-template>
                    <div class="row">
                      <!-- <div class="col-12 text-center" style="text-align: justify;">
                        {{ element.object.offreService.offre.description }}
                      </div> -->
                      <!-- <div class="col-12 text-center mt-2">
                        <h4>Annexe d'Akassato</h4>
                      </div> -->
                      <div class="col-12 text-center">
                        Du {{ element.object.dateDebut | date: 'dd-MM-yyyy' }} au {{ element.object.dateFin | date: 'dd-MM-yyyy' }}
                      </div>
                      <div class="col-12 text-center">
                        <h5 class="text-primary">{{ element.object.offreService.montant }} FCFA</h5>
                      </div>
                    </div>
                    <ng-template pTemplate="footer">
                      <span *ngFor="let item of element.adresses">
                        <b>{{ item.typeAdresse }}: </b> {{ item.valeur }} <br>
                      </span>
                    </ng-template>
                  </p-card>
                </div>
              </div>
            </div>
          </div>
  
            <!-- <div *ngIf="offres.length !== 0" class="row mt-3">
              <div *ngFor="let service of offres" class="col-6">
                <p-card>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5>{{ service.nom }}</h5>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 text-center">
                      {{ service.description }}
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div *ngIf="!service.permanent" class="col-12 text-center">
                      Du {{ service.dateDebut }} au {{ service.dateFin }}
                    </div>
                    <div class="col-12 text-center mt-2">
                      <h4><b>{{ service.montant }}</b></h4>
                    </div>
                    <div class="col-12 text-center mt-2">
                    Chaque {{ service.periodicite.nom }}
                    </div>
                  </div> -->
                <!-- </p-card>
              </div>
            </div> -->
        </div>
      </div>
      
    </div>
  </div>

  <div class="row mt-2">
    <div *ngIf="inscriptions.length === 0" class="col-12 mt-2">
      <div class="row">
        <!-- <p-message severity="info" text="Aucune offre choisi"></p-message> -->
        Aucune offre choisi
      </div>
    </div>

    <div *ngIf="inscriptions.length !== 0" class="col-12 mt-2">
      <!-- [paginator]="true" -->
      <p-table
        [value]="inscriptions"
        [rows]="5"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[5]"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
            <tr>
                <th>Site</th>
                <th>Offre</th>
                <th>Montant</th>
                <th>Date</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.periodicite.offreService.service.nom }}</td>
                <td>{{ item.periodicite.offreService.offre.nom }}</td>
                <td>{{ item.periodicite.offreService.montant }}</td>
                <td>{{ item.periodicite.dateDebut | date: 'dd-MM-yyyy' }} au {{ item.periodicite.dateFin | date: 'dd-MM-yyyy' }}</td>
                <td>
                  <span class="pi pi-trash" style="cursor: pointer;" [ngStyle]="{color: 'var(--red-500)'}" pTooltip="Retirer" tooltipPosition="bottom"></span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 mt-4 justify-content-center">
    <div class="col-12 col-md-6 mb-2">
      <button type="submit" style="color: white !important;">Envoyer</button>
    </div>
  </div>

</form>

